export default __webpack_public_path__ + "static/media/greyEnvelope.ed0d690a.svg";